/**
 * Preserve React Router parameter placeholders (for example `:id`) while
 * safely encoding concrete route values before interpolating them into URLs.
 */
const encodeSegment = (value) => {
  const segment = String(value ?? '').trim();
  return segment.startsWith(':') ? segment : encodeURIComponent(segment);
};

export const publicRoutes = Object.freeze({
  home: () => '/',
  listings: () => '/listings',
  listing: (slug = ':slug') => `/listings/${encodeSegment(slug)}`,
  offers: () => '/offers',
  blog: () => '/blog',
  experts: (slug) => slug ? `/experts/${encodeSegment(slug)}` : '/experts',
  about: () => '/about',
  communityProgram: (slug = ':slug') => `/community-programs/${encodeSegment(slug)}`,
  communityProgramBallot: (slug = ':slug') => `/community-programs/${encodeSegment(slug)}/ballot`,
  communityProgramNominee: (id = ':id') => `/vote/${encodeSegment(id)}`,
  pricing: () => '/advertise/spotlight',
});

export const manageRoutes = Object.freeze({
  home: () => '/manage',
  listings: () => '/manage/listings',
  listing: (id = ':id') => `/manage/listings/${encodeSegment(id)}`,
  listingEdit: (id = ':id') => `/manage/listings/${encodeSegment(id)}/edit`,
  offers: () => '/manage/offers',
  mailers: () => '/manage/mailers',
  content: () => '/manage/content',
  settings: () => '/manage/settings',
});

export const adminRoutes = Object.freeze({
  home: () => '/admin',
  tenants: () => '/admin/tenants',
  tenant: (id = ':id') => `/admin/tenants/${encodeSegment(id)}`,
  listings: () => '/admin/listings',
});

export const routes = Object.freeze({
  public: publicRoutes,
  manage: manageRoutes,
  admin: adminRoutes,
});

export default routes;
